// Centrally-managed work category taxonomy for internal bookings.
// Main categories with dependent subcategories (see booking enhancement spec).
export const WORK_CATEGORIES = [
  { id: "mechanical", label: "Mechanical Repairs", subs: ["Engine Repair", "Clutch Replacement", "Gearbox Repair", "Brake Repairs", "Suspension Repairs", "Steering Repairs", "Exhaust Repairs", "Cooling System", "Timing Belt / Timing Chain", "General Mechanical Repair"] },
  { id: "bodywork", label: "Bodywork & Accident Repair", subs: ["Accident Damage Repair", "Bumper Repair", "Panel Beating", "Dent Removal", "Scratch Repair", "Paintwork", "Full Respray", "Alloy Wheel Repair", "Smart Repair", "Other Bodywork"] },
  { id: "servicing", label: "Servicing", subs: ["Interim Service", "Full Service", "Major Service", "Oil & Filter Change", "Brake Inspection", "Vehicle Inspection", "Pre-Purchase Inspection"] },
  { id: "diagnostics", label: "Diagnostics", subs: ["Engine Warning Light", "ECU Diagnostics", "Electrical Fault Finding", "Battery & Charging System", "Sensor Faults", "General Diagnostics"] },
  { id: "tyres", label: "Tyres & Wheels", subs: ["Tyre Replacement", "Puncture Repair", "Wheel Balancing", "Wheel Alignment", "Alloy Wheel Repair", "Tyre Inspection"] },
  { id: "recovery", label: "Recovery", subs: ["Vehicle Recovery", "Breakdown Recovery", "Roadside Assistance", "Vehicle Transportation"] },
];

export const OCCUPANCY_STATUSES = [
  { v: "not_arrived", l: "Not Arrived" },
  { v: "vehicle_received", l: "Vehicle Received" },
  { v: "in_workshop", l: "In Workshop" },
  { v: "awaiting_parts", l: "Awaiting Parts" },
  { v: "awaiting_collection", l: "Awaiting Collection" },
  { v: "vehicle_collected", l: "Vehicle Collected" },
];

export const PRIORITIES = [
  { v: "normal", l: "Normal" },
  { v: "urgent", l: "Urgent" },
  { v: "emergency", l: "Emergency" },
];

export const occupancyLabel = (v) => (OCCUPANCY_STATUSES.find((o) => o.v === v) || {}).l || "";
export const priorityLabel = (v) => (PRIORITIES.find((o) => o.v === v) || {}).l || "";
export const categoryLabel = (id) => (WORK_CATEGORIES.find((c) => c.id === id) || {}).label || id || "";
